<template>
  <div class="containerFull_olympicGames">
    <CompreSportsMeetCommon
      :bigSportsList="bigSportsList"
      :containerFullClassName="containerFullClassName"
      :defaultPath="defaultPath"
      :axiosBaseUrl="axiosBaseUrl"
      :sportCompetitionType="sportCompetitionType"
      :themeSeasonArr="themeSeasonArr"
    ></CompreSportsMeetCommon>
  </div>
</template>

<script>
// 奥运会 容器
import CompreSportsMeetCommon from './compreSportsMeet_common'
import containerFull_data from '@mixins/compreSportsMeet/SOG/containerFull_data'
export default {
  name: 'containerFull_olympicGames',
  mixins: [containerFull_data],
  components: {
    CompreSportsMeetCommon,
  },
}
</script>
